/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconEPICDocument = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--epicdocument',
    className,
  )

  return (
    <IconBase className={classes} viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"{...rest}><path className="path1" fillRule="evenodd" clip-rule="evenodd" d="M.01 2C.01.9.9 0 2 0h8l6 6v12c0 1.1-.9 2-2 2H1.99C.89 20 0 19.1 0 18L.01 2zM9 1.5V7h5.5L9 1.5z" fill="#6D6D6D"/></IconBase>
  )
}

IconEPICDocument.propTypes = {
  className: PropTypes.string,
}

export default IconEPICDocument
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconEPICDocument.js